// src/routes/ProcurementRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import GoodsReceivedNoteListPage from '../pages/goodsReceivedNote/GoodsReceivedNoteListPage';
import CreateGoodsReceivedNotePage from '../pages/goodsReceivedNote/CreateGoodsReceivedNotePage';
import GoodsReceivedNoteDetailsPage from '../pages/goodsReceivedNote/GoodsReceivedNoteDetailsPage';
import ReturnToVendorListPage from '../pages/returnToVendor/ReturnToVendorListPage';
import CreateReturnToVendorPage from '../pages/returnToVendor/CreateReturnToVendorPage';
import ReturnToVendorDetailsPage from '../pages/returnToVendor/ReturnToVendorDetailsPage';
import DebitNoteListPage from '../pages/debitNote/DebitNoteListPage';
import CreateDebitNotePage from '../pages/debitNote/CreateDebitNotePage';
import DebitNoteDetailsPage from '../pages/debitNote/DebitNoteDetailsPage';
import PayablesPage from '../pages/procurement/PayablesPage';
import SupplierStatementPage from '../pages/procurement/SupplierStatementPage';

const ProcurementRoutes = () => (
  <Routes>
    <Route
      path="grn"
      element={
        <PermissionRoute requiredPermission="view_grn">
          <GoodsReceivedNoteListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="grn/create"
      element={
        <PermissionRoute requiredPermission="create_grn">
          <CreateGoodsReceivedNotePage />
        </PermissionRoute>
      }
    />
    <Route
      path="grn/:grnId"
      element={
        <PermissionRoute requiredPermission="view_grn">
          <GoodsReceivedNoteDetailsPage />
        </PermissionRoute>
      }
    />
    <Route
      path="return-to-vendor"
      element={
        <PermissionRoute requiredPermission="view_rtv">
          <ReturnToVendorListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="return-to-vendor/create"
      element={
        <PermissionRoute requiredPermission="create_rtv">
          <CreateReturnToVendorPage />
        </PermissionRoute>
      }
    />
    <Route
      path="return-to-vendor/:rtvId"
      element={
        <PermissionRoute requiredPermission="view_rtv">
          <ReturnToVendorDetailsPage />
        </PermissionRoute>
      }
    />
    <Route
      path="debit-notes"
      element={
        <PermissionRoute requiredPermission="view_debit_note">
          <DebitNoteListPage />
        </PermissionRoute>
      }
    />
    <Route
      path="debit-notes/create"
      element={
        <PermissionRoute requiredPermission="issue_debit_note">
          <CreateDebitNotePage />
        </PermissionRoute>
      }
    />
    <Route
      path="debit-notes/:debitNoteId"
      element={
        <PermissionRoute requiredPermission="view_debit_note">
          <DebitNoteDetailsPage />
        </PermissionRoute>
      }
    />
    <Route
      path="payables"
      element={
        <PermissionRoute requiredPermission="view_payables">
          <PayablesPage />
        </PermissionRoute>
      }
    />
    <Route
      path="suppliers/:supplierId/statement"
      element={
        <PermissionRoute requiredPermission="view_payables">
          <SupplierStatementPage />
        </PermissionRoute>
      }
    />
  </Routes>
);

export default ProcurementRoutes;
